import { render } from "./NotificationsInformer.vue?vue&type=template&id=312cadb0&scoped=true"
import script from "./NotificationsInformer.vue?vue&type=script&lang=js"
export * from "./NotificationsInformer.vue?vue&type=script&lang=js"

import "./NotificationsInformer.vue?vue&type=style&index=0&id=312cadb0&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-312cadb0"]])

export default __exports__